module.exports = __webpack_public_path__ + "img/military_man.cf203adb.png";